exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user_info[data-v-dd75817a] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\n}\n.user_info .ant-row.ant-form-item[data-v-dd75817a] {\r\n    width: 100%;\r\n    margin-right: 6px;\n}\r\n", ""]);

// exports
